import { render } from "./MobileOfferProduct.vue?vue&type=template&id=f64fb942"
import script from "./MobileOfferProduct.vue?vue&type=script&lang=js"
export * from "./MobileOfferProduct.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ulas\\Desktop\\projeler\\eku\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__